import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import InfoSharpIcon from "@mui/icons-material/InfoSharp";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormLabel,
  Grid,
  Stack,
  TextField,
  Typography,
  styled,
} from "@mui/material/";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import { DatePicker } from "@mui/x-date-pickers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Switch, { SwitchProps } from "@mui/material/Switch";
import noLocation from "../../../images/nosupplier.png";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { availabilityReportActions } from "../service/availabilityReport.actions";
import FileSaver from "file-saver";
import { useTranslation } from "react-i18next";
import {
  AggregatedByLmsGroupRespons,
  AggregatedRow,
  ConfigurationThreshold,
  GetAllAvailabilityPayload,
  SelectedLocations,
  SingleLocationAvailabilityReportResponses,
} from "../service/availabilityReportInterfaces";
import TotalsTable from "./TotalsTable";
import "./availabilityReportOld.css";
import { useSearchParams } from "react-router-dom";
import CustomLoader from "../../../../../util/component/CustomLoader";
import SectionHeader from "../../../../../util/component/SectionHeader";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { ContextOperation } from "../../../context/OperationContext";
import useTenant from "../../../hooks/useTenant";
import OperationTypes from "../../../types";
import { AutoCompleteOption } from "../../common/AutoComplete";
import FormInput from "../../common/FormInput";
import SingleLocationTableOld from "./SingleLocationTableOld";
import { atom, useRecoilState } from "recoil";

export const reportOldTimezoneState = atom<string>({
    key: 'reportOldTimezoneState',
    default: "Europe/Rome"
})

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 50,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(24px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          theme.palette.mode === "dark" ? "#2ECA45" : "rgb(200, 1, 125)",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const AvailabilityReportOld = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const { t } = useTranslation(["operation"]);
  const { i18n } = useTranslation();
  const { dispatchGlobalData, globalData } = useContext(GlobalContext);
  const availabilityReport = availabilityReportActions();
  const [loading, setLoading] = useState<boolean>(false);
  const [singleLocationAvailability, setSingleLocationAvailability] =
    React.useState<SingleLocationAvailabilityReportResponses[]>([]);
  const [aggregatedGroupresponses, setAggregatedGroupresponses] =
    React.useState<AggregatedByLmsGroupRespons[]>([]);
  const [configurationThresholds, setConfigurationThresholds] = useState<
    ConfigurationThreshold[]
  >([]);
  const [totalRows, setTotalRows] =  useState<AggregatedRow[]>([]);
  const [allLocations, setAllLocations] = useState<any[]>([]);
  const [locations, setLocations] = useState<any[]>([]);
  const [location, setLocation] = useState<SelectedLocations[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<any[]>([]);
  const [getElement, setElement] = useState(false);
  const [totalCurrentAvailability, setTotalCurrentAvailability] = useState<number>();
  const [totalCurrentUtilization, setTotalCurrentUtilization] = useState<number>();
  const [allCarSegments, setAllCarSegments] = useState<
    OperationTypes.CarSegmentCategory[]
  >([]);

  const [optionsCarSegments, setOptionsCarSegments] = useState<
    AutoCompleteOption[]
  >([]);
  const [selectedCarSegment, setSelectedCarSegment] =
    useState<OperationTypes.CarSegmentCategory>();
  const [optionsCarClass, setOptionsCarClass] = useState<AutoCompleteOption[]>(
    []
  );
  const [selectedCarClass, setSelectedCarClass] =
    useState<OperationTypes.CarClassCategory>();
  const [optionsCarAcriss, setOptionsCarAcriss] = useState<
    AutoCompleteOption[]
  >([]);
  const [selectedCarAcriss, setSelectedCarAcriss] =
    useState<OperationTypes.AcrissCategory>();
  const [optionsCarSipps, setOptionsCarSipps] = useState<AutoCompleteOption[]>(
    []
  );
  const [selectedCarSipps, setSelectedCarSipps] =
    useState<OperationTypes.SippsCategory>();

  const [carSegment, setCarSegment] = useState<any>("");
  const [carClass, setCarClass] = useState<any>("");
  const [carAcriss, setCarAcriss] = useState<any>("");
  const [carSipps, setCarSipps] = useState<any>("");
  const [isPickupTenantPresent, setIsPickupTenantPresent] = useState(false)

  const [fullDays, setFullDays] = useState<boolean>(true);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState<any>(false);
  const [dialogData, setDialogData] = useState<any>({});
  const [initial, setInitial] = useState<boolean>(false);
  const { tenant,setTenant } = useContext(ContextOperation);
  const { TenantAutocomplete, resetTenant,setPickupTenant } = useTenant();

  const ref = useRef(i18n?.language);

  const checkinEstimatedLocationType = [
    {
      id: "PARKING_GO",
      descr: t("internOptionSelectName.physicalLocationType.parkingGo"),
    },
    { id: "LMS", descr: t("internOptionSelectName.physicalLocationType.lms") },
    {
      id: "COMPOUND",
      descr: t("internOptionSelectName.physicalLocationType.compound"),
    },
    {
      id: "SHOP_REPAIR",
      descr: t("internOptionSelectName.physicalLocationType.shopRepair"),
    },
  ];

  function getLocationTypeTranslation(locationType: string) {
    const translation = checkinEstimatedLocationType.filter(
      (i) => i.id === locationType
    );
    return translation.length > 0 ? translation[0].descr : locationType;
  }

  const getAllData = (payload: GetAllAvailabilityPayload) => {
    setSingleLocationAvailability([]);
    setAggregatedGroupresponses([]);
    setTotalRows([]);
    setLoading(true);
    availabilityReport
      .getAllData(tenant, payload)
      .then((response: any) => {
        response.singleLocationAvailabilityReportResponses.forEach(function (
          location: any
        ) {
          location.isVisible = true;
        });
        setSingleLocationAvailability(
          response.singleLocationAvailabilityReportResponses
        );
        setAggregatedGroupresponses(response.aggregatedByLmsGroupResponses);
        setConfigurationThresholds(response.configurationThresholds);
        setTotalRows(response.totalRows);
        setTotalCurrentAvailability(response.totalCurrentAvailability);
        setTotalCurrentUtilization(response.totalCurrentUtilization);
        setLoading(false);
      })
      .catch((error: any) => {
        setSingleLocationAvailability([]);
        setAggregatedGroupresponses([]);
        setTotalRows([]);
        setLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: "Error has happened",
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };

  const getAllCarSegments = (pickupCarSegmentParam: string | null) => {
    if (tenant !== "all") {
      availabilityReport
        .getAllCarSegmentsAndClasses(tenant)
        .then((response) => {
          setCarSegment(
            response.find(
              (segment) => segment.categoryName === pickupCarSegmentParam
            )?.categoryId
          );
          setAllCarSegments(response);
          setOptionsCarSegments(
            response.map((element) => ({
              label: element.categoryName,
              value: element.categoryId,
            }))
          );
        })
        .catch((error: any) => {
          console.log("error", error);
        });
    }
  };

  
  const [_, setTimezone] = useRecoilState(reportOldTimezoneState);

  const getAllLocationGroup = (tenant: string) => {

    if (tenant === "drivalia_pt") {
      // TODO: Change me, in the future
      setTimezone("Europe/Lisbon")
    } else {
      setTimezone("Europe/Rome")
    }

    if (tenant !== "all") {
      availabilityReport
        .getAllLocationAngGroup(tenant)
        .then((response: any) => {
          setLocations(response);

          const pickupLocationId = searchParams.get("pickupLocationId");
          const pickupLocationType = searchParams.get("pickupLocationType");
          const pickupCarSegment = searchParams.get("pickupCarSegment");
          const pickupCentralDatetime = searchParams.get(
            "pickupCentralDatetime"
          );

          const urlTenant = searchParams.get("tenant")
          if(!isPickupTenantPresent){
            const defaultTenant = globalData?.user?.legalEntities?.length === 1
              ? globalData?.user?.legalEntities[0]?.name
              : 'drivalia_it';
            setPickupTenant(urlTenant ?? defaultTenant)
            setIsPickupTenantPresent(true)
          }
                   

          const isQueryStringValid = Boolean(
            pickupLocationId && pickupLocationType && pickupCentralDatetime
          );

          setInitial(isQueryStringValid);

          let datesFromParams: { start: dayjs.Dayjs; end: dayjs.Dayjs } = {
            start: dayjs(),
            end: dayjs(),
          };

          if (isQueryStringValid) {
            datesFromParams = {
              start: dayjs(dayjs(pickupCentralDatetime).subtract(15, "days")),
              end: dayjs(dayjs(pickupCentralDatetime).add(15, "days")),
            };
          }

          let allData = response.map((loc: any) => {
            let currentLoc = [];

            const label = loc.element.locationList
              ? `${loc.element.displayName} (${t(
                  `availabilityReport.groupEnums.${loc.element.groupType}`
                )})`
              : `${loc.element.displayName} ` +
                "(" +
                getLocationTypeTranslation(loc.element.locationType) +
                ")";

            const pureLabel = loc.element.locationList
              ? `${loc.element.displayName}`
              : `${loc.element.displayName} ` +
                "(" +
                getLocationTypeTranslation(loc.element.locationType) +
                ")";
            currentLoc.push({
              ...loc,
              label: label,
              pureLabel: pureLabel,
              locationType: loc.element.locationType,
              elementType: loc.elementType,
              id: loc.element.id,
              mainId: loc.element.id,
              isChild: false,
              isParent: Boolean(loc.element.locationList),
              groupType: loc.element.groupType,
            });
            if (loc.element.locationList) {
              loc.element.locationList.map((location: any) => {
                currentLoc.push({
                  ...location,
                  label:
                    `${location.displayName}` +
                    " (" +
                    getLocationTypeTranslation(location.locationType) +
                    ")",
                  locationType: location.locationType,
                  elementType: loc.elementType,
                  id: location.id,
                  mainId: loc.element.id,
                  isChild: true,
                });
              });
            }
            return currentLoc;
          });

          const flattenedData = allData.flat();
          const foundLocation = flattenedData.find(
            (location: any) =>
              location.id === pickupLocationId &&
              location.locationType === pickupLocationType
          ) as SelectedLocations;
          setLocation((prevState) =>
            foundLocation ? [foundLocation] : prevState
          );

          setAllLocations(flattenedData);
        })
        .catch((error: any) => {
          console.log("error", error);
        });
    }
  };


  useEffect(() => {
    onClickCancelWithoutTenant();
  }, [tenant]);

  const formatDate = (
    initialStart: dayjs.Dayjs,
    initialEnd: dayjs.Dayjs,
    isFromParams: boolean
  ): {
    formattedStartDate: dayjs.Dayjs | string;
    formattedEndDate: dayjs.Dayjs | string;
  } => {
    const currentDay = dayjs(initialStart).isSame(dayjs(initialEnd));

    let formattedStartDate = null;
    let formattedEndDate = null;
    let start: dayjs.Dayjs = initialStart;
    let end: dayjs.Dayjs = initialEnd;

    if (currentDay) {
      start = dayjs(dayjs(initialStart).add(1, "days"));
      end = fullDays
        ? dayjs(dayjs(initialStart).add(31, "days"))
        : dayjs(dayjs(initialStart).add(15, "days"));
    }

    if (isFromParams) {
      return {
        formattedStartDate: dayjs(start).toISOString(),
        formattedEndDate: dayjs(end).toISOString(),
      };
    }

    if (fullDays) {
      formattedStartDate = start
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .utc(true)
        .toISOString();
      formattedEndDate = end
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(999)
        .utc(true)
        .toISOString();
    } else {
      if (dayjs().format("A") === "AM") {
        formattedStartDate = start
          .hour(12)
          .minute(0)
          .second(0)
          .millisecond(0)
          .utc(true)
          .toISOString();
        formattedEndDate = end
          .hour(23)
          .minute(59)
          .second(59)
          .millisecond(999)
          .utc(true)
          .toISOString();
      } else {
        formattedStartDate = start
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .utc(true)
          .toISOString();
        formattedEndDate = end
          .hour(11)
          .minute(59)
          .second(59)
          .millisecond(999)
          .utc(true)
          .toISOString();
      }
    }

    return { formattedStartDate, formattedEndDate };
  };

  const onClickProceed = (isInitial: any) => {
    const datesDiff = dayjs(endDate).diff(startDate, "days");

    if (datesDiff < 0) {
      setDialogData({
        title: t("availabilityReport.dialog.date.title"),
        body: t("availabilityReport.dialog.date.descriptionBody"),
      });

      setOpen(true);
      return;
    }

    // if carClass selected, send car class; otherwise send carSegment
    const selectedGroup =
      selectedCarSipps ||
      selectedCarAcriss ||
      selectedCarClass ||
      selectedCarSegment;

    const formatSelectedGroup =
      isInitial && !!searchParams.get("pickupCarSegment")
        ? {
            categoryName: searchParams.get("pickupCarSegment"),
            categoryType: "CAR_SEGMENT",
          }
        : selectedGroup;

    // handle all selected locations
    const pickUpList =
      location.map((item) => {
        if (item.locationType) {
          return {
            locationType: item.locationType,
            locationId: item.id,
            displayName: item.label,
          };
        } else {
          let temp = locations.filter(
            (loc) =>
              loc.element.id === item.id && loc.elementType === item.elementType
          )[0].element.locationList;
          let tempArray: any[] = [];
          temp?.map((el: any) => {
            tempArray.push({
              locationType: el.locationType,
              locationId: el.id,
              displayName: el.displayName,
            });
          });
          return tempArray;
        }
      }) || [];

    setSelectedLocations([...Object.values(pickUpList.flat())]);

    const { formattedStartDate, formattedEndDate } = formatDate(
      dayjs(startDate),
      dayjs(endDate),
      isInitial
    );

    const getAllPayload: any = {
      pickUpList: [...Object.values(pickUpList.flat())],
      ...(isInitial
        ? { group: formatSelectedGroup }
        : selectedGroup && { group: formatSelectedGroup }),
      fullDays: fullDays,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      delta: 0,
    };
    //console.log(getAllPayload, "getAllPayload");
    getAllData(getAllPayload);
  };

  useEffect(() => {
    const pickupLocationId = searchParams.get("pickupLocationId");
    const pickupLocationType = searchParams.get("pickupLocationType");
    const pickupCarSegment = searchParams.get("pickupCarSegment");
    const pickupCentralDatetime = searchParams.get("pickupCentralDatetime");

    const isQueryStringValid = Boolean(
      pickupLocationId && pickupLocationType && pickupCentralDatetime
    );

    let datesFromParams: { start: dayjs.Dayjs; end: dayjs.Dayjs } = {
      start: dayjs(),
      end: dayjs(),
    };

    if (isQueryStringValid) {
      const subtractedStartDate = dayjs(
        dayjs(pickupCentralDatetime).subtract(15, "days")
      );
      const paramsStartDate =
        dayjs(subtractedStartDate).isSame(dayjs()) ||
        dayjs(subtractedStartDate).isBefore(dayjs())
          ? dayjs().add(1, "days")
          : subtractedStartDate;
      const paramsEndDate =
        dayjs(subtractedStartDate).isSame(dayjs()) ||
        dayjs(subtractedStartDate).isBefore(dayjs())
          ? dayjs(paramsStartDate.add(15, "days"))
          : dayjs(dayjs(pickupCentralDatetime).add(15, "days"));

      datesFromParams = {
        start: paramsStartDate,
        end: paramsEndDate,
      };
    }

    const { formattedStartDate, formattedEndDate } = formatDate(
      isQueryStringValid ? datesFromParams.start : dayjs(),
      isQueryStringValid ? datesFromParams.end : dayjs(),
      isQueryStringValid
    );

    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
    getAllCarSegments(pickupCarSegment);
    getAllLocationGroup(tenant);
  }, [tenant]);

  useMemo(() => {
    //console.log(getElement, "urlLocation");
    //console.log(tenant, "tenantttt");
    if (initial) {
      onClickProceed(initial);
    }
  }, [getElement]);

  useEffect(() => {
    setAllLocations(
      allLocations.map((location) => {
        return {
          ...location,
          ...(location.isParent && {
            label: `${location.pureLabel} (${t(
              `availabilityReport.groupEnums.${location.groupType}`
            )})`,
          }),
        };
      })
    );
    if (
      ref.current !== i18n?.language &&
      singleLocationAvailability.length !== 0
    ) {
      ref.current = i18n?.language;
      onClickProceed(initial);
    }
  }, [i18n?.language]);

  const downloadExcel = () => {
    setLoading(true);

    // if carClass selected, send car class; otherwise send carSegment
    const selectedCategory =
      selectedCarSipps ||
      selectedCarAcriss ||
      selectedCarClass ||
      selectedCarSegment;
    const selectedGroup = selectedCategory ? [selectedCategory] : undefined;

    // handle all selected locations
    const pickUpList =
      location.map((item) => {
        if (item.locationType) {
          return {
            locationType: item.locationType,
            locationId: item.id,
            displayName: item.label,
          };
        } else {
          let temp = locations.filter(
            (loc) =>
              loc.element.id === item.id && loc.elementType === item.elementType
          )[0].element.locationList;
          let tempArray: any[] = [];
          temp?.map((el: any) => {
            tempArray.push({
              locationType: el.locationType,
              locationId: el.id,
              displayName: el.displayName,
            });
          });
          return tempArray;
        }
      }) || [];

    setSelectedLocations([...Object.values(pickUpList.flat())]);

    const getAllPayload: any = {
      locations: [...Object.values(pickUpList.flat())],
      ...(selectedGroup && { categories: selectedGroup }),
      startDate: startDate,
      endDate: endDate,
    };

    availabilityReport
      .downloadExcel(tenant, getAllPayload)
      .then((response: any) => {
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
        setLoading(false);
      })
      .catch((e: any) => {
        setLoading(false);
      });
  };

  const onClickCancel = () => {
    resetTenant();
    setSingleLocationAvailability([]);
    setAggregatedGroupresponses([]);
    setTotalRows([]);
    setTotalCurrentAvailability(undefined);
    setTotalCurrentUtilization(undefined);
    setLocation([]);
    setCarSegment("");
    setSelectedLocations([]);
  };
  const onClickCancelWithoutTenant = () => {
    setSingleLocationAvailability([]);
    setAggregatedGroupresponses([]);
    setTotalRows([]);
    setTotalCurrentAvailability(undefined);
    setTotalCurrentUtilization(undefined);
    setLocation([]);
    setCarSegment("");
    setSelectedLocations([]);
  };

  const onFilterClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    locationId: number,
    locationType: string,
  ) => {
    let temp = [...singleLocationAvailability];
    const index = temp.findIndex(
      (el) => el?.location?.locationId === String(locationId) && el.location.locationType === locationType
    );
    temp[index].isVisible = event.target.checked;
    setSingleLocationAvailability(temp);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const filterOptions = (options: any, { inputValue }: any) => {
    if (inputValue) {
      const parentOptions = options.filter(
        (option: any, index: any, self: any) => {
          return (
            !option.isChild &&
            option?.label?.toLowerCase().includes(inputValue.toLowerCase())
          );
        }
      );
      const parentOptionsFlatMainIds = parentOptions.map(
        (parent: any) => parent.mainId
      );
      return options.filter((option: any) =>
        parentOptionsFlatMainIds.includes(option.mainId)
      );
    } else {
      return options;
    }
  };

  // On update car segment
  useEffect(() => {
    setCarClass("");

    if (carSegment) {
      const selCarSegment = allCarSegments?.find(
        (item) => item?.categoryId === carSegment
      );
      setOptionsCarClass(
        selCarSegment?.carClasses?.map((carClass) => ({
          label: carClass.categoryName,
          value: carClass.categoryId,
        })) || []
      );
      setSelectedCarSegment(selCarSegment);
    } else {
      setSelectedCarSegment(undefined);
    }
  }, [carSegment]);

  useEffect(() => {
    setCarAcriss("");

    if (carClass) {
      const selCarClass = selectedCarSegment?.carClasses.find(
        (item) => item.categoryId === carClass
      );
      setOptionsCarAcriss(
        selCarClass?.acrisses.map((element) => ({
          label: element.categoryName,
          value: element.categoryId,
        })) || []
      );
      setSelectedCarClass(selCarClass);
    } else {
      setSelectedCarClass(undefined);
    }
  }, [carClass]);

  useEffect(() => {
    setCarSipps("");

    if (carAcriss) {
      const selCarAcriss = selectedCarClass?.acrisses.find(
        (item) => item.categoryId === carAcriss
      );
      setOptionsCarSipps(
        selCarAcriss?.sipps.map((element) => ({
          label: element.categoryName,
          value: element.categoryId,
        })) || []
      );
      setSelectedCarAcriss(selCarAcriss);
    } else {
      setSelectedCarAcriss(undefined);
    }
  }, [carAcriss]);

  useEffect(() => {
    if (carSipps) {
      const selCarSipps = selectedCarAcriss?.sipps.find(
        (item) => item.categoryId === carSipps
      );
      setSelectedCarSipps(selCarSipps);
    } else {
      setSelectedCarSipps(undefined);
    }
  }, [carSipps]);

  useMemo(() => {
    let getLocation = allLocations.find(
      (el) => el.id == searchParams?.get("pickupLocationId")
    );
    if (getLocation !== undefined) {
      setElement(!getElement);
    }
  }, [allLocations]);

  return (
    <span className="availabilityReport availabilityReportForecast">
      <SectionHeader title={t("availabilityReport.mainTitle")} />
      
      <Box
        className="carGenericOuterFilterBox"
        sx={{ backgroundColor: "white" }}
      >
        {loading && <CustomLoader loading={loading} />}
        <form>
          <Grid
            container
            spacing={2}
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid item xs={12}>
              <Typography className="filtersHeader">
                {t("availabilityReport.settings")}
              </Typography>
            </Grid>
            {/* <FormControl  >{TenantAutocomplete}</FormControl> */}
            <Grid item xs={12}>
              <Grid container spacing={2.5}>
                <Grid item xl={9} lg={9} md={6} xs={12}>
                  <Grid container columns={9} spacing={2.5}>
                    {TenantAutocomplete}

                    <Grid item xs={3}>
                      <Autocomplete
                        id="lmsAutocomplete"
                        multiple
                        value={location}
                        options={allLocations}
                        filterOptions={filterOptions}
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, data) => {
                          setLocation(data);
                          if (data.length === 0) {
                            setSingleLocationAvailability([]);
                            setAggregatedGroupresponses([]);
                            setSelectedLocations([]);
                            setTotalRows([]);
                            setTotalCurrentAvailability(undefined);
                            setTotalCurrentUtilization(undefined);
                          }
                        }}
                        getOptionDisabled={(option) => option.isChild}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("availabilityReport.lmsLabel")}
                            variant="standard"
                            fullWidth
                          />
                        )}
                        renderOption={(props, option, state) => {
                          return (
                            <li {...props} key={`${option.id}-${option.mainId}-${option.locationType}`}>
                              <Typography
                                sx={{
                                  ...(option.isChild && { paddingLeft: 2 }),
                                }}
                                variant={option.isParent ? "h6" : "body1"}
                              >
                                {option.label}
                              </Typography>
                            </li>
                          );
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <FormInput
                        name="carSegment"
                        type="select"
                        label={t("availabilityReport.carSegmentLabel")}
                        options={optionsCarSegments}
                        value={carSegment}
                        fullWidth
                        onChange={(value) => setCarSegment(value)}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <FormInput
                        name="carClass"
                        type="select"
                        label={t("availabilityReport.carClassLabel")}
                        value={carClass}
                        options={optionsCarClass}
                        onChange={(value) => setCarClass(value)}
                        disabled={!carSegment}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <FormInput
                        name="acriss"
                        type="select"
                        label={t("availabilityReport.carAcrissLabel")}
                        value={carAcriss}
                        options={optionsCarAcriss}
                        onChange={(value) => setCarAcriss(value)}
                        disabled={!carClass}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <FormInput
                        name="sipps"
                        type="select"
                        label={t("availabilityReport.carSippsLabel")}
                        value={carSipps}
                        options={optionsCarSipps}
                        onChange={(value) => setCarSipps(value)}
                        disabled={!carAcriss}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <DatePicker
                        label={t("availabilityReport.startDateLabel")}
                        inputFormat="DD-MM-YYYY"
                        value={startDate}
                        onChange={(date) => {
                          setStartDate(dayjs(date));

                          if (dayjs(date).isAfter(dayjs(endDate))) {
                            setEndDate(dayjs(date).add(1, "days"));
                          }
                        }}
                        minDate={
                          fullDays
                            ? dayjs().add(1, "days")
                            : dayjs().format("A") === "AM"
                            ? dayjs()
                            : dayjs().add(1, "days")
                        }
                        renderInput={(params) => (
                          <TextField fullWidth {...params} variant="standard" />
                        )}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <DatePicker
                        label={t("availabilityReport.endDateLabel")}
                        inputFormat="DD-MM-YYYY"
                        value={endDate}
                        onChange={(date) => setEndDate(dayjs(date))}
                        minDate={dayjs(startDate).add(1, "days")}
                        renderInput={(params) => (
                          <TextField fullWidth {...params} variant="standard" />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xl={3} lg={3} md={6} xs={12}>
                  <FormControl variant="standard" fullWidth>
                    <FormLabel component="legend" className="filtersHeader">
                      {t("availabilityReport.tableView")}
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          sx={{ m: 1 }}
                          checked={fullDays}
                          onChange={(event) =>
                            setFullDays(event.target.checked)
                          }
                        />
                      }
                      label={t("availabilityReport.fullDays")}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Typography className="filtersHeader">
                {t("availabilityReport.filterLMS")}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              {selectedLocations.map((location, index) => (
                <FormControlLabel
                  key={`${location.locationId}-${location.locationType}-${index}`}
                  control={
                    <Checkbox
                      defaultChecked
                      sx={{
                        color: "rgb(200, 1, 125)",
                        "&.Mui-checked": {
                          color: "rgb(200, 1, 125)",
                        },
                      }}
                      onChange={(e) => onFilterClick(e, location.locationId, location.locationType)}
                    />
                  }
                  className="locationCheckbox"
                  label={location.displayName}
                />
              ))}
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <Box>
                  {(singleLocationAvailability.length !== 0 || aggregatedGroupresponses.length !== 0) && (
                    <Button
                      className="mainTitleDownloadButton"
                      onClick={downloadExcel}
                      variant="outlined"
                      size="medium"
                      color="accent"
                      endIcon={<FileDownloadIcon />}
                    >
                      <Typography
                        className="mainTitleDownloadButtonText"
                        variant="button"
                      >
                        {t("tooltipTitle.downloadExcel")}
                      </Typography>
                    </Button>
                  )}
                </Box>
                
                <Box>
	                <Button
	                  className="remove-hover-Reset"
	                  variant="outlined"
	                  onClick={onClickCancel}
	                >
	                  <span className="ResetButton">
	                    {t("actionButtons.reset")}
	                  </span>
	                </Button>
	                <Button
	                  className="remove-hover-Save"
	                  variant="contained"
	                  onClick={() => onClickProceed(false)}
	                >
	                  <span className="SaveButtonSpan">
	                    {t("actionButtons.search")}
	                  </span>
	                </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
      {singleLocationAvailability.length === 0 &&
        aggregatedGroupresponses.length === 0 && (
          <Box>
            <Stack
              sx={{ height: "500px" }}
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Box>
                <img src={noLocation} />
              </Box>
              <Box>
                <p className="notSupplietClass">
                  {t("availabilityReport.noLocation")}
                </p>
              </Box>
            </Stack>
          </Box>
        )}
      {singleLocationAvailability.map((availability, index) =>
        availability.isVisible ? (
          <SingleLocationTableOld
            key={`${availability?.location?.locationId}-${availability?.location?.locationType}-${index}`}
            location={availability.location}
            rowsPerAcriss={availability.rowsPerAcriss}
            configurationThresholds={configurationThresholds} 
            fullDays={fullDays}
            index={index}
            totalRowsByLocation={availability.totalRowsByLocation}
            totalCurrentAvailability={availability.totalCurrentAvailability}
            totalCurrentUtilization={availability.totalCurrentUtilization}
          />
        ) : (
          <></>
        )
      )}
      {aggregatedGroupresponses.length !== 0 && (
        <TotalsTable
          rowsPerAcriss={aggregatedGroupresponses}
          configurationThresholds={configurationThresholds}
          fullDays={fullDays}
          totalRowsByLocation={totalRows}
          totalCurrentAvailability={totalCurrentAvailability}
          totalCurrentUtilization={totalCurrentUtilization || 0}
        />
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <Box sx={{ display: "flex" }}>
            <InfoSharpIcon
              sx={{
                color: "#C8017D",
                marginRight: "17px",
              }}
            />

            <Typography fontWeight={"bold"} color={"primary"}>
              {dialogData.title}
            </Typography>
          </Box>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {dialogData.bodyTitle && (
            <DialogContentText
              id="alert-dialog-description"
              style={{ marginBottom: 20 }}
            >
              {dialogData.bodyTitle}
            </DialogContentText>
          )}

          <DialogContentText id="alert-dialog-description">
            {dialogData.body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}> Close </Button>
        </DialogActions>
      </Dialog>
    </span>
  );
};

export default AvailabilityReportOld;
